<content>
    <section class="entry-inline-framed">
        <label>{{'gestionLicencias.historial.licencia' | translate}}</label> {{licenciaId}}
        <label>{{'gestionLicencias.historial.usuario' | translate}}</label> {{userName}}
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th>{{'gestionLicencias.historial.table.fecha' | translate}}</th>
                        <th class="string">{{'gestionLicencias.historial.table.operacion' | translate}}</th>
                    </tr>
                </thead>
                <tbody *ngFor="let item of licenciaHistorial">
                    <tr>
                        <td>{{item.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="string">{{item.activada ? ('gestionLicencias.historial.table.activacion' | translate) : ('gestionLicencias.historial.table.desactivacion' | translate)}}</td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!licenciaHistorial || (licenciaHistorial && licenciaHistorial.length < 1)">
                    <tr>
                        <td colspan="2">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="licenciaHistorial && licenciaHistorial.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cerrar' | translate}}</button>
</footer>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
